import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import DropdownSelector from "./DropdownSelector";
import { API_URL } from '../../../environment';

interface LeadData {
  key: number;
  LeadName: string;
  Phone: string;
  Tags: string;
  Data: string;
  Cnpj: string;
  Razao: string;
  Obs: string;
  Funil?: string;
}


interface MobileLeadCardProps {
  lead: LeadData;
  onClick: () => void;
}

const MobileLeadCard: React.FC<MobileLeadCardProps> = ({ lead, onClick }) => (
  <div className="card p-3 mb-2 shadow-sm" style={{ cursor: "pointer" }} onClick={onClick}>
    <h6 className="mb-1 fw-semibold" style={{ color: "#000" }}>{lead.LeadName}</h6>
    <p style={{ marginBottom: 0, color: "#000" }}>{lead.Phone}</p>
    <button className="btn btn-sm btn-outline-primary mt-2">Ver Card</button>
  </div>
);

interface MobileLeadDetailProps {
  lead: LeadData;
  onBack: () => void;
}

const MobileLeadDetail: React.FC<MobileLeadDetailProps> = ({ lead, onBack }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";
    return new Intl.DateTimeFormat("pt-BR").format(date);
  };

  const updateFunnelStage = async (fone: string, novaEtapa: string) => {
    const idcliente = localStorage.getItem("id_cliente");
    await fetch(`${API_URL}/atualizaretapa`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fone, nova_etapa: novaEtapa, idcliente }),
    });
  };

  const updateFunnelPage = async (fone: string, novaPagina: string) => {
    const idcliente = localStorage.getItem("id_cliente");
    await fetch(`${API_URL}/atualizarpagina`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fone, nova_pagina: novaPagina, idcliente }),
    });
  };

  const etapas = JSON.parse(localStorage.getItem("etapas") || "[]");
  const funis = JSON.parse(localStorage.getItem("funis") || "[]");

  return (
    <div className="card p-3">
      <button className="btn btn-sm btn-outline-secondary mb-3" onClick={onBack}>
        Voltar
      </button>
      <div style={{ color: "#000" }}>
        <p><strong>Nome:</strong> {lead.LeadName}</p>
        <p><strong>Telefone:</strong> {lead.Phone}</p>

        <div className="mb-2">
          <strong>Etapa:</strong>
          
            <DropdownSelector
              currentText={lead.Tags}
              buttonClassName="badge bg-secondary"
              items={etapas.map((etapa: any) => ({
                id: etapa.id,
                label: etapa.nome_funil,
              }))}
              onSelect={(selectedLabel: string) => {
                fetch(`${API_URL}/atualizaretapa`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    fone: lead.Phone,
                    nova_etapa: selectedLabel,
                    idcliente: localStorage.getItem("id_cliente"),
                  }),
                }).then(() => alert("Etapa atualizada"));
              }}
            />

        </div>

        <div className="mb-2">
          <strong>Funil:</strong>
          
            <DropdownSelector
              currentText={lead.Funil || localStorage.getItem("nome_pai") || ""}
              buttonClassName="badge bg-secondary"
              items={funis.map((funil: any) => ({
                id: funil.id,
                label: funil.nome_funil,
              }))}
              onSelect={(selectedLabel: string) => {
                fetch(`${API_URL}/atualizarpagina`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    fone: lead.Phone,
                    nova_pagina: selectedLabel,
                    idcliente: localStorage.getItem("id_cliente"),
                  }),
                }).then(() => alert("Funil atualizado"));
              }}
            />
            
        </div>

        <p><strong>Data de Entrada:</strong> {formatDate(lead.Data)}</p>
        {lead.Cnpj && <p><strong>CNPJ:</strong> {lead.Cnpj}</p>}
        {lead.Razao && <p><strong>Razão Social:</strong> {lead.Razao}</p>}
        {lead.Obs && <p><strong>Observação:</strong> {lead.Obs}</p>}
      </div>
    </div>
  );
};

interface LeadsListMobileProps {
  leads: LeadData[];
}

const LeadsListMobile: React.FC<LeadsListMobileProps> = ({ leads }) => {
  const [selectedLead, setSelectedLead] = useState<LeadData | null>(null);

  if (selectedLead) {
    return <MobileLeadDetail lead={selectedLead} onBack={() => setSelectedLead(null)} />;
  }

  return (
    <div className="p-3">
      {leads.map((lead) => (
        <MobileLeadCard key={lead.key} lead={lead} onClick={() => setSelectedLead(lead)} />
      ))}
    </div>
  );
};

interface ResponsiveLeadsListProps {
  desktopComponent: React.ReactNode;
  mobileLeads: LeadData[];
  /** Vista mobile rica (cards + detalhe) montada na página, com acesso aos
   *  estados/handlers (etapa, funil, atendente). Se omitida, usa o fallback. */
  mobileComponent?: React.ReactNode;
}

export const ResponsiveLeadsList: React.FC<ResponsiveLeadsListProps> = ({
  desktopComponent,
  mobileLeads,
  mobileComponent,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  if (!isMobile) return <>{desktopComponent}</>;
  return <>{mobileComponent ?? <LeadsListMobile leads={mobileLeads} />}</>;
};
